import 'bootstrap';
import slick from 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'swiper/css/bundle';
import { initSlider } from "./js/includes/slider";

(($) => {
    $(document).ready(() => {
        initSlider($);
    });
})(jQuery);
